module.exports = __webpack_public_path__ + "static/media/priorly-logo-animated.6dc5dc66.svg";